import { ReactNode } from 'react'

import { ViewTypeContext } from '@/modules/shared/contexts/view-type/ViewTypeContext'
import { ViewType } from '@/modules/shared/types/ViewType'

interface ViewTypeProviderProps {
  viewType: ViewType
  children: ReactNode
}

/**
 * Provider component that makes the view type available to all child components
 * @param viewType - The current view type (Purchaser, Supplier, Utility)
 * @param children - Child components that will have access to the view type
 */
export function ViewTypeProvider({ viewType, children }: ViewTypeProviderProps) {
  return <ViewTypeContext.Provider value={viewType}>{children}</ViewTypeContext.Provider>
}
